import { useLanguage } from '../contexts/LanguageContext';
import translations from '../locales/translations.json';

type TranslationKey = string;

function useTranslation() {
  const { language } = useLanguage();

  /**
   * Získá překlad podle klíče s podporou interpolace proměnných
   * @param key - Klíč ve formátu "section.subsection.key" např. "home.title"
   * @param params - Objekt s hodnotami pro interpolaci, např. { email: 'test@test.com' }
   * @returns Přeložený text s nahrazenými proměnnými
   */
  const t = (key: TranslationKey, params?: Record<string, string>): string => {
    const keys = key.split('.');
    let value: any = translations[language];

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        // Pokud klíč neexistuje, vrátí klíč jako fallback
        console.warn(`Translation key "${key}" not found for language "${language}"`);
        return key;
      }
    }

    let result = typeof value === 'string' ? value : key;

    // Interpolace proměnných {{variable}}
    if (params) {
      Object.keys(params).forEach((param) => {
        result = result.replace(new RegExp(`{{\\s*${param}\\s*}}`, 'g'), params[param]);
      });
    }

    return result;
  };

  return { t, language };
}

export { useTranslation };
